import { render, staticRenderFns } from "./dashangs.vue?vue&type=template&id=fe3c4e8e&scoped=true&"
import script from "./dashangs.vue?vue&type=script&lang=js&"
export * from "./dashangs.vue?vue&type=script&lang=js&"
import style0 from "./dashangs.vue?vue&type=style&index=0&id=fe3c4e8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe3c4e8e",
  null
  
)

export default component.exports